
let user = JSON.parse(localStorage.getItem('user'));
const getProfileFiscalYears = (notGetCompanyFiscalYear) => {
    //let user = JSON.parse(localStorage.getItem('user'));
    
    /*if(!notGetCompanyFiscalYear){
        let currentCompany = JSON.parse(localStorage.getItem('currentCompany'));
        currentCompany = user.currentCompany!=null?user.currentCompany:currentCompany;
        if (currentCompany) {
            return currentCompany.fiscal_years_elite;
        } else {
            return user.fiscal_years;
        }
    }
    return user.fiscal_years;*/

    const fiscal_years = JSON.parse(localStorage.getItem('fiscal_years')) ?? []

    return fiscal_years.filter(fy => fy.block == 0)
}

const getFiscalYears = (notGetCompanyFiscalYear = false) => {
    let fiscalYears = getProfileFiscalYears(notGetCompanyFiscalYear);
    try {
        return fiscalYears;
    } catch (error) {
        return [];
    }
}

const getSelectedFiscalYear = (fiscalYearId) => {

    let fiscalYears = getProfileFiscalYears(true);

    fiscalYears = fiscalYears.filter((value, key) => {
      return value.id == fiscalYearId;
    })[0];

    return fiscalYears;
}

const getCurrentFiscalYear = (v = true) => {
    const fiscalYears = getProfileFiscalYears(v);
    const current_fy = fiscalYears[fiscalYears.length - 1]
    return current_fy.id
}

export {
    getFiscalYears,
    getSelectedFiscalYear,
    getCurrentFiscalYear
};

export default {};